import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

import { Text } from '../../../../../react-components/Text';

export const RouteSurveyThanks = () => {
  return (
    <Grid key="step-2" className="animate__animated animate__fadeIn">
      <Grid
        container
        direction="row"
        alignItems="center"
        justifyContent="center"
        flexWrap={`nowrap`}
        position={`relative`}
      >
        <Text
          variant="small"
          intlId="route_survey.step-2.thanks.v2"
          style={{ color: RoutalPalette.secondary00, textAlign: `center` }}
        />
      </Grid>
    </Grid>
  );
};
